import { Injectable } from '@angular/core';

const LOADING_MESSAGES = [
  '640K ought to be enough for anybody',
  'the architects are still drafting',
  'the bits are breeding',
  'we\'re building the buildings as fast as we can',
  'would you prefer chicken, steak, or tofu?',
  'pay no attention to the man behind the curtain',
  'and enjoy the elevator music',
  'while the little elves draw your map',
  'a few bits tried to escape, but we caught them',
  'and dream of faster computers',
  'would you like fries with that?',
  'checking the gravitational constant in your locale',
  'go ahead -- hold your breath',
  'at least you\'re not on hold',
  'hum something loud while others stare',
  'you\'re not in Kansas any more',
  'the server is powered by a lemon and two electrodes',
  'we love you just the way you are',
  'while a larger software vendor in Seattle takes over the world',
  'we\'re testing your patience',
  'as if you had any other choice',
  'take a moment to sign up for our lovely prizes',
  'don\'t think of purple hippos',
  'follow the white rabbit',
  'why don\'t you order a sandwich?',
  'while the satellite moves into position',
  'the bits are flowing slowly today',
  'dig on the \'X\' for buried treasure... ARRR!',
  'it\'s still faster than you could draw it',
];

@Injectable()
export class FilteringService {

  private ActiveFilters = {};
  constructor() { }

  public all() {
    return this.ActiveFilters;
  }

  public set(key: string, value: string | number | boolean | Date): void {
    this.ActiveFilters[key] = value;
  }

  public get(key: string): string | number | boolean | Date {
    return this.ActiveFilters[key];
  }

  public getString(key: string): string {
    const f = this.ActiveFilters[key];
    if (f) {
      return f.toString();
    }
    return null;
  }

  public remove(key: string): void {

    delete this.ActiveFilters[key];
  }

  public combined(paging?: LocalPagingFilter) {
    const p = { skip: paging.skip, take: paging.take, orderBy: paging.orderBy, orderDirection: paging.orderDirection };
    return { ...this.ActiveFilters, ...paging.filters, ...p };
  }
}

export class LocalPagingFilter {

  public pageSizes = [5, 10, 15, 25, 50, 75, 100];
  public orderDirections = ['ASC', 'DESC'];
  public filters: any = {};
  public loading = false;
  public loadingMessage = LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)];
  public page = 1;
  public take = 10;
  public skip = 0;
  public total = 0;
  public orderBy = 'updatedAt';
  public orderDirection = 'DESC';

  public toggleLoading() {
    this.loading = !this.loading;
    if (this.loading) {
      this.loadingMessage = LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)];
    }
  }

  public set(key: string, value: string | number | boolean | Date): void {
    this.filters[key] = value;
  }

  public get(key: string): string | number | boolean | Date {
    return this.filters[key];
  }
}
